import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { env } from '@shared/config';
import { defaultLocale } from './config';
import { getLocale, getCookieDomain } from './lib';

import commonKK from './translations/common/kk.json';
import commonRU from './translations/common/ru.json';

import mainPageRU from './translations/main/ru.json';
import mainPageKK from './translations/main/kk.json';

import tourCardRU from './translations/tour-card/ru.json';
import tourCardKK from './translations/tour-card/kk.json';

import searchFormRU from './translations/search-form/ru.json';
import searchFormKK from './translations/search-form/kk.json';

import errorCardRU from './translations/error-card/ru.json';
import errorCardKK from './translations/error-card/kk.json';

import searchResultsRU from './translations/search-results/ru.json';
import searchResultsKK from './translations/search-results/kk.json';

import tourDetailsRU from './translations/tour-details/ru.json';
import tourDetailsKK from './translations/tour-details/kk.json';

import bookingRU from './translations/booking/ru.json';
import bookingKK from './translations/booking/kk.json';

import paymentRU from './translations/payment/ru.json';
import paymentKK from './translations/payment/kk.json';

import navigationRU from './translations/navigation/ru.json';
import navigationKK from './translations/navigation/kk.json';

import plugRU from './translations/plug/ru.json';
import plugKK from './translations/plug/kk.json';

import footerRU from './translations/footer/ru.json';
import footerKK from './translations/footer/kk.json';

import kidsGoFreeRU from './translations/kids-go-free/ru.json';
import kidsGoFreeKK from './translations/kids-go-free/kk.json';

import tourderMainRU from './translations/tourder/main/ru.json';
import tourderMainKK from './translations/tourder/main/kk.json';

import seoMainRU from './translations/seo/main/ru.json';
import seoMainKK from './translations/seo/main/kk.json';

import simpleFlowMainMobileRU from './translations/simple-flow/main/mobile/ru.json';
import simpleFlowMainMobileKK from './translations/simple-flow/main/mobile/kk.json';

import simpleFlowHotelDetailsRU from './translations/simple-flow/hotel-details/ru.json';
import simpleFlowHotelDetailsKK from './translations/simple-flow/hotel-details/kk.json';

import simpleFlowGeneralRU from './translations/simple-flow/general/ru.json';
import simpleFlowGeneralKK from './translations/simple-flow/general/kk.json';

import requestFormRU from './translations/request-form/ru.json';
import requestFormKK from './translations/request-form/kk.json';

export { getLocale, validationI18n, isSupportedLocale } from './lib';
export { AppLocale, defaultLocale } from './config';

export const resources = {
  ru: {
    translation: {
      common: commonRU,
      'main-page': mainPageRU,
      'tour-card': tourCardRU,
      'search-form': searchFormRU,
      'error-card': errorCardRU,
      'search-results': searchResultsRU,
      'tour-details': tourDetailsRU,
      booking: bookingRU,
      payment: paymentRU,
      navigation: navigationRU,
      footer: footerRU,
      plug: plugRU,
      'kids-go-free': kidsGoFreeRU,
      'tourder-main': tourderMainRU,
      seo: {
        main: seoMainRU,
      },
      'simple-flow': {
        'main-mobile': simpleFlowMainMobileRU,
        'hotel-details': simpleFlowHotelDetailsRU,
        general: simpleFlowGeneralRU,
      },
      'request-form': requestFormRU,
    },
  },
  kk: {
    translation: {
      common: commonKK,
      'main-page': mainPageKK,
      'tour-card': tourCardKK,
      'search-form': searchFormKK,
      'error-card': errorCardKK,
      'search-results': searchResultsKK,
      'tour-details': tourDetailsKK,
      booking: bookingKK,
      payment: paymentKK,
      navigation: navigationKK,
      footer: footerKK,
      plug: plugKK,
      'kids-go-free': kidsGoFreeKK,
      'tourder-main': tourderMainKK,
      seo: {
        main: seoMainKK,
      },
      'simple-flow': {
        'main-mobile': simpleFlowMainMobileKK,
        'hotel-details': simpleFlowHotelDetailsKK,
        general: simpleFlowGeneralKK,
      },
      'request-form': requestFormKK,
    },
  },
} as const;

if (env.MODE === 'development' && !env.IS_SSR) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.i18next = i18next;
}

/**
 * TODO: Pass translations in setupI18N method not to load them all at the same time
 */
export function setupI18N(locale: string) {
  return i18next.use(LanguageDetector).init({
    lng: getLocale(locale),
    debug: env.MODE !== 'production' && !env.IS_SSR,
    ns: ['translation'],
    defaultNS: 'translation',
    detection: {
      caches: ['cookie'],
      lookupCookie: 'aviata_language',
      cookieMinutes: 60 * 24 * 90,
      cookieDomain: getCookieDomain(),
    },
    fallbackLng: defaultLocale,
    resources,
  });
}
